export default {
	getAlert : state => index => state.alerts[index],
	findAlertIndex : state => alert => {
		return state.alerts.findIndex(a => {
			return ! Object.keys(alert).some(k => {
				return ! alert[k] || alert[k] !== a[k]
			})
		})
	},
	findAlert : (state, getters) => alert => {
		const index = getters.findAlertIndex(alert)
		return -1 === index ? false : getters.getAlert(index)
	},
}
